import colors, { appTheme } from '@/config/colors';
import { isPatientApp } from '@/config/constants';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  subtext: {
    color: colors.newUI.therapist.textBlue100,
    marginTop: 8,
  },

  avatar: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 20,
    color: appTheme.primary,
    ...(isPatientApp
      ? {
          backgroundColor: colors.newUI.therapist.green10,
          borderWidth: 2,
          borderColor: colors.newUI.therapist.brandGreen,
        }
      : {}),
  },

  itemContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    paddingHorizontal: isPatientApp ? 0 : 20,
  },
});
